import { ListNode } from '@lexical/list'
import { DOMExportOutput, LexicalEditor } from 'lexical'
import { ListTheme } from '../plugins/listPlugin'

// ListNodeはネストされたリストに対し余計な<li>を生成してしまう問題がある。
// その問題に対応するため、ListNodeを拡張してネストされたリストの処理をカスタマイズする。
// 下記を参考に実装している。
// https://github.com/facebook/lexical/issues/2951#issuecomment-2761489020
export class ExtendedListNode extends ListNode {
  static getType(): string {
    return 'extended-list'
  }

  static clone(node: ExtendedListNode): ExtendedListNode {
    return new ExtendedListNode(
      node.getListType(),
      node.getStart(),
      node.getKey()
    )
  }

  override exportDOM(editor: LexicalEditor): DOMExportOutput {
    const { after: originalAfter, ...rest } = super.exportDOM(editor)
    const after = (generatedElement?: HTMLElement | Text | null) => {
      if (
        !generatedElement ||
        (!(generatedElement instanceof HTMLOListElement) &&
          !(generatedElement instanceof HTMLUListElement))
      ) {
        return originalAfter?.(generatedElement)
      }

      const listItems = Array.from(generatedElement.querySelectorAll('li'))

      listItems.forEach((li, i) => {
        // ネストされたリストではない場合、処理しない
        if (!li.classList.contains(ListTheme.nested.listitem)) return

        // ネストされたリストの親のリストを取得
        const parentLi = listItems[i - 1]

        // ネストされたリスト内に要素がある場合、親の直下に追加
        if (parentLi && li.firstElementChild) {
          parentLi.appendChild(li.firstElementChild)
        }

        // ネストされたリストを削除
        li.remove()
      })
      return originalAfter?.(generatedElement)
    }

    return { after, ...rest }
  }
}
